import React from "react";
import Logo from "/logo.svg";

const FoundryConnectLogo: React.FC = () => {
  return (
    <div className="mb-8">
      <img
        className="mx-auto h-18 w-auto duration-200 ease-in-out"
        src={Logo}
        alt="Foundry Connect"
      />
      <h2 className="text-xl text-center leading-9 tracking-wider font-semibold text-gray-700">
        Foundry Connect
      </h2>
    </div>
  );
};

export default FoundryConnectLogo;
